import { Slide, toast } from "react-toastify";
import {
  ErrorToast,
  InfoToast,
  SuccessToast,
  WarnToast,
} from "../assets/images";

// export const tostS = (msg) => {
//   var toastId = null;
//   var customToastId = 1234;
//   if (toast.isActive(toastId)) {
//     toastId = toast.success(msg);
//   }

//   toast.success(msg, {
//     toastId: customToastId,
//     icon: <img src={SuccessToast} alt="success" />,
//   });
// };

export const tostS = (msg) => {
  toast.success(msg, {
    icon: <img src={SuccessToast} alt="success" />,
    autoClose: 3000,
    transition: Slide,
  });
};

export const tostE = (msg) => {
  toast.error(msg, {
    icon: <img src={ErrorToast} alt="error" />,
    autoClose: 3000,
    transition: Slide,
  });
};

export const tostW = (msg) => {
  toast.warn(msg, {
    icon: <img src={WarnToast} alt="warn" />,
    autoClose: 3000,
    transition: Slide,
  });
};

export const tostI = (msg) => {
  toast.info(msg, {
    icon: <img src={InfoToast} alt="info" />,
    autoClose: 3000,
    transition: Slide,
  });
};
